import React from 'react';
import HelpIcon from '@material-ui/icons/ContactSupport';
import Button from '../Button';
import { UNIT } from '../../constants';

class Title extends React.PureComponent {
  render() {
    const { title, onClick, style } = this.props;
    return (
      <div style={{ display: 'flex' }}>
        <h3 className='page-title py-3 pr-2 mb-0' style={style}>
          {title}
        </h3>
        {onClick && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '2px'
            }}
          >
            <Button
              color='link'
              onClick={onClick}
              style={{
                alignSelf: 'center',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <HelpIcon style={{ height: `${UNIT * 1.75}px`, width: `${UNIT * 1.75}px` }} />
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default Title;
